export default {
  translation: {
    'Validation - field - required': '{{ fieldName }} は必須です',
    'Sign Up': '新規登録',
    'Mobile Number': '電話番号',
    Email: 'メールアドレス',
    'Enter your email': 'メールアドレスを入力してください',
    'Accept to receive store updates':
      '{{ shopName }} から最新割引情報やサービスプロモーション関連情報の受信を希望する',
    'Terms of Use and Privacy Policy':
      '<0>利用規約</0>および<2>プライバシー ポリシー</2>に同意します。',
    'Terms of Use and Privacy Policy and Age Policy':
      '<0>利用規約</0>および<2>プライバシー ポリシー</2>に同意します。また、私は{{ 年齢 }} 歳以上です。',
    Next: '次へ',
    'Already a member': 'すでにアカウントをお持ちですか？',
    'Sign in to enjoy more benefits':
      'ログインしてぜひ割引をお楽しみください！',
    'Validation - email - required': 'メールアドレスは必須です',
    'Validation - email - invalid': '無効な電子メール',
    'Validation - email - max': 'メールが長すぎます',
    'Validation - mobile phone - required': '携帯電話番号は必須です',
    'Validation - mobile phone - invalid': '無効な電話番号',
    'Validation - terms and policy - required':
      '利用規約とプライバシーポリシーに同意してください',
    'Continue Sign up': '登録を続ける',
    'Sign In': 'ログイン',
    'Register Status - result - email belongs to guest':
      'このメールはこのストアですでに使用されています。アカウント設定手順については、メールを確認してください。',
    'Register Status - result - email belongs to member':
      'このメールはすでに登録済みです。ログインページに移動するか、別のメールを使用して登録を完了してください。',
    'Register Status - result - mobile phone belongs to guest':
      'この携帯電話番号はすでにこのストアで使用されています。アカウントの設定手順についてはSMSをご確認ください。',
    'Register Status - result - mobile phone belongs to member':
      'この電話番号はすでに登録済みです。ログインページに移動するか、別の電話番号を使用して登録を完了してください。',
    'Register Status - result - email and mobile phone both not allowed':
      'メールアドレスと携帯電話番号が別々に登録されています。ログインしてください。',
    'Register Status - result - email is taken':
      'このメールはすでに別のアカウントに存在します',
    'Register Status - result - mobile phone is taken':
      'この電話はすでに別のアカウントに存在します',
    'Verify mobile number': '携帯電話番号を認証',
    'Verification code': '認証コード',
    'Enter verification code': '認証コードを入力してください',
    'Send verification code': '認証コードを送信',
    'Resend Verification Code': '認証コードを再送',
    'Seconds left': '{{ seconds }} 秒',
    'Verification code will be sent after you pass reCAPTCHA':
      'reCAPTCHAテストに通過後、認証コードが送信されます',
    'Verification code has been sent to':
      '認証コードが +{{countryCode}} {{phoneNumber}} に送信されました',
    Back: 'ひとつ戻る',
    'Validation - pincode - required': '認証コードは必須です',
    'Validation - pincode - max length':
      '検証コードは {{ maxLength }} 以上にしてください',
    'Validation - pincode - invalid': '認証コードが無効です',
    'Last Step': '最後のステップ',
    'Please enter your profile':
      '必要情報を入力して、登録手続きを完了してください',
    Username: 'ユーザー名',
    'Enter your username': 'ユーザー名を入力してください',
    Password: 'パスワード',
    'Password(at least 8 characters)': 'パスワード（8文字以上）',
    Gender: '性別',
    'Gender - male': '男性',
    'Gender - female': '女性',
    'Gender - undisclosed': '回答なし',
    Birthday: '生年月日',
    'Birthday - year': '年',
    'Birthday - month': '月',
    'Birthday - date': '日',
    'Validation - birthday - invalid': '生年月日が無効です',
    'Validation - birthday - min age':
      '生年月日が無効です。{{age}} 歳以上である必要があります',
    'Validation - birthday - required': '生年月日は必須です',
    Optional: '(オプション)',
    'Sign me up': '今すぐはじめる',
    'Validation - username - required': 'ユーザー名は必須です',
    'Validation - password - required': 'パスワードは必須です',
    'Validation - password - too short': 'パスワードが短すぎます',
    'Validation - password - too long': 'パスワードが長すぎます',
    'Email or Mobile Number': 'メールアドレスまたは携帯電話番号',
    'Password (8 characters minimum)': 'パスワード（8文字以上）',
    'Forgot Password': 'パスワードをお忘れですか?',
    'Lets go': 'ショッピングを始めましょう！',
    'Not a member': 'ご登録がまだですか？',
    'Validation - email and mobile - required':
      'メールアドレスまたは携帯電話番号は必須です',
    'Validation - email and mobile - invalid':
      '無効なメールアドレスまたは携帯電話番号',
    'Sign up Success': 'ありがとうございます！アカウント登録が完了しました！',
    'Complete member info': 'メンバープロフィールの完了',
    'Complete Phone Number Notice':
      '携帯電話番号を入力して、より詳しいキャンペーン情報を取得',
    'Complete Email Notice':
      'メールアドレスを入力して、より詳しいキャンペーン情報を取得',
    Complete: '完了',
    Skip: 'スキップ',
    'sign up with social account': 'またはソーシャルアカウントを使用して登録',
    'login in with social account': 'その他のログイン方法',
    'Login - email - label': 'またはソーシャルアカウントを使用してログイン',
    'Login - email - placeholder': 'メールアドレスを入力してください',
    'Login - mobile phone - label': '電話番号',
    'Login - mobile phone - placeholder': '電話番号を入力してください',
    'Login - email or mobile phone - label': 'メールアドレスまたは携帯電話番号',
    'Login - email or mobile phone - placeholder':
      'メールアドレスまたは携帯電話番号を入力してください',
    'Login - Error - unconfirmed email':
      'おかえりなさい！アカウントのセキュリティ保護のため、ログイン前にアカウント認証を完了する必要があります。認証メールが {{email}} に送信されました。確認して認証を実行してください。',
    'Login - Info - module reset password hint':
      'パスワードを再設定後、こちらから再度ログインしてください。',
    'Member info has been updated': 'メンバープロフィール更新完了',
    'Subscription - description':
      'ソーシャルプラットフォームを使用して、割引情報やサービスプロモーションなどの情報を購読',
    'Subscription - LINE - subscribe': 'LINEで購読',
    'Subscription - connection notification - success': '登録完了',
    'Subscription - LINE - connection notification - failure':
      '登録に失敗しました。再度LINEにログインしてください',
    'Verification - email - trial merchant - reach limit - failure':
      'ストアはトライアル中のため、確認メールを送信できません。必要な場合はストアまでご連絡ください。',
    'Subscription - FACEBOOK - connection notification - failure':
      '登録に失敗しました。Facebookに再度ログインしてください',
    'Default Text Title': '入会すると以下の特典が受けられます：',
    'Default Text Welcome Credits': '入会特典：{{amount}} のストアクレジット',
    'Default Text Birthday Credits': '毎年の誕生日ストアクレジット',
    'Default Text Membership Tier Discount': '会員限定割引',
    'Default Text Earn Points From Order': 'お買い物でポイントが貯まる',
    'Default Text Desc': 'その他不定期でスペシャル特典',
    'Default Text No Condition': '会員登録でもっとお得な特典を手に入れましょう',
  },
};
